import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FiEdit } from "react-icons/fi";
import { fetchPastorContentList } from "../../store/devotionSlice";

const isoDate = (date) => date.toISOString().slice(0, 10);

const PastorDevotionDashboard = () => {
  const dispatch = useDispatch();
  const rows = useSelector((state) => state.devotions.pastorContentList);
  const [from, setFrom] = useState(isoDate(new Date()));

  useEffect(() => {
    const start = new Date(`${from}T00:00:00`);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    dispatch(fetchPastorContentList({ from, to: isoDate(end) }));
  }, [dispatch, from]);

  const statusFor = (contents, language) => {
    const content = contents.find((item) => item.language_code === language);
    return content ? content.status : "missing";
  };

  return (
    <main className="min-h-screen bg-cover px-4 py-6" style={{ backgroundImage: "url('/images/brick.jpg')" }}>
      <div className="mx-auto max-w-6xl bg-white/90 p-5 rounded-lg shadow-sm">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="text-sm font-semibold uppercase tracking-wide text-emerald-900">Super Admin</p>
            <h1 className="text-2xl font-bold text-gray-900">Daily Devotions</h1>
          </div>
          <div className="flex flex-wrap items-center gap-3">
            <Link
              to="/admin/reading-plans"
              className="inline-flex min-h-[44px] items-center gap-2 rounded-md border border-emerald-800 px-3 font-semibold text-emerald-900 hover:bg-emerald-50"
            >
              Reading Plans →
            </Link>
            <label className="grid gap-1 text-sm font-semibold text-gray-700">
              <span>Starting date</span>
              <input type="date" value={from} onChange={(event) => setFrom(event.target.value)} className="min-h-[44px] rounded-md border border-gray-300 px-3" />
            </label>
          </div>
        </div>
        <nav aria-label="Admin sections" className="mt-4 flex flex-wrap items-center gap-2 text-sm">
          <span className="text-gray-500">Admin areas:</span>
          <Link to="/admin/devotions" className="font-semibold text-emerald-900 underline">Devotional Content</Link>
          <span className="text-gray-400">·</span>
          <Link to="/admin/reading-plans" className="font-semibold text-emerald-900 hover:underline">Reading Plans</Link>
        </nav>

        <div className="mt-6 overflow-x-auto">
          <table className="w-full min-w-[760px] text-left">
            <thead>
              <tr className="border-b border-gray-300 text-sm uppercase text-gray-600">
                <th className="py-3">Date</th>
                <th>Passage</th>
                <th>Korean</th>
                <th>English</th>
                <th>Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(({ passage, contents }) => (
                <tr key={passage.id} className="border-b border-gray-200">
                  <td className="py-3 font-semibold">{passage.passage_date}</td>
                  <td>{passage.reference_ko}<br /><span className="text-sm text-gray-600">{passage.reference_en}</span></td>
                  <td>{statusFor(contents, "ko")}</td>
                  <td>{statusFor(contents, "en")}</td>
                  <td>{contents[0]?.updated_at?.slice(0, 10) || ""}</td>
                  <td>
                    <div className="flex flex-wrap gap-2">
                      <Link to={`/admin/devotions/${passage.id}/ko`} className="inline-flex min-h-[44px] items-center gap-2 rounded-md border border-emerald-800 px-3 font-semibold text-emerald-900">
                        <FiEdit aria-hidden="true" />
                        KO
                      </Link>
                      <Link to={`/admin/devotions/${passage.id}/en`} className="inline-flex min-h-[44px] items-center gap-2 rounded-md border border-emerald-800 px-3 font-semibold text-emerald-900">
                        <FiEdit aria-hidden="true" />
                        EN
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
              {!rows.length && (
                <tr>
                  <td colSpan="6" className="py-8 text-gray-600">No scheduled passages found in this range.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </main>
  );
};

export default PastorDevotionDashboard;
